import {LENS_APP_LEGACY_URL, LENS_APP_PROD_URL} from 'app/utils/constants';
import * as historyUtils from 'app/utils/historyUtils';
import * as routeUtils from 'app/utils/routeUtils';

/** The in-app route a URL names, or null when it points somewhere else. */
export function inAppPath(href: string | undefined): string | null {
  const url = parseLensUrl(href);
  // The router reads a path starting `//` as another host, so following it
  // would leave Lens.
  if (!url || url.pathname.startsWith('//')) {
    return null;
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

export function isLensUrl(href: string | undefined): boolean {
  return parseLensUrl(href) !== null;
}

/**
 * The URL when it is on one of our origins. The page's own origin, the origin
 * the app builds its links against, the root the app mints absolute links
 * against, and the deployed app all count as ours — a URL minted server-side
 * names production even when this tab is a local or staging build, and off prod
 * that root is `localhost:9999` whatever port this tab runs on.
 */
function parseLensUrl(href: string | undefined): URL | null {
  if (!href) {
    return null;
  }
  try {
    const url = new URL(href, window.location.origin);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return null;
    }
    const appOrigin = new URL(routeUtils.makeAppUrl('/'), window.location.origin).origin;
    const rootOrigin = new URL(historyUtils.ROOT_URL).origin;
    const ours = new Set([
      window.location.origin,
      appOrigin,
      rootOrigin,
      LENS_APP_PROD_URL,
      LENS_APP_LEGACY_URL,
    ]);
    return ours.has(url.origin) ? url : null;
  } catch {
    return null;
  }
}
